<header class="ComparePlansHeader">
  <div class="container">
    @if (highlightedPlans.length) {
      <section class="ComparePlansHeader__Row">
        @for (plan of plans; track plan) {
          <div class="ComparePlansHeader__Cell">
            @if (getHighlightedPlanHeader(plan)) {
              <status
                [config]="{ label: getHighlightedPlanHeader(plan) }"
                status="info"
              ></status>
            }
          </div>
        }
      </section>
    }

    <section class="ComparePlansHeader__Row">
      <div class="ComparePlansHeader__Cell">
        <zip-button
          class="ComparePlansHeader__BackButton"
          [config]="{
            level: 'text',
            icon: 'chevron_left',
            fill: 'primary',
            content:
              comparePlansConfig?.label?.backToPlans || 'Back to All Plans',
          }"
          (zipButtonClicked)="goBackToAllPlans()"
        >
        </zip-button>
      </div>

      @for (plan of plans; track plan) {
        <div
          class="ComparePlansHeader__Cell"
          [ngClass]="{ 'ComparePlansHeader__Cell--Scrolled': isScrolled }"
        >
          <div class="ComparePlansHeader__Cell">
            @switch (comparePlansConfig?.headerCardType) {
              @case ('RoundedCorner') {
                <h6
                  class="ComparePlansHeader__Title t-bold"
                  [innerHTML]="plan.display_name"
                ></h6>
                @if (!!plan.star_rating && comparePlansConfig?.showStarRating) {
                  <section class="ComparePlansHeader__Rating">
                    <star-rating [rating]="plan.star_rating"></star-rating>
                  </section>
                }
                <div class="u-justifyBetween u-alignCenter">
                  @if (plan.subsidyText?.value) {
                    <div>
                      <h6
                        class="t-bold"
                        [innerHTML]="plan.subsidyText?.discountedPrice"
                      ></h6>
                      <div>
                        <p
                          class="t-data"
                          [innerHTML]="plan.subsidyText?.subsidyLabel"
                        ></p>
                        <p
                          class="t-data"
                          [innerHTML]="plan.subsidyText?.originalPriceLabel"
                        ></p>
                        <br />
                      </div>
                    </div>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="withoutSubsidy"
                    ></ng-container>
                  }
                  <ng-template #withoutSubsidy>
                    <span
                      class="t-bold"
                      [innerHTML]="
                        (comparePlansConfig?.text || comparePlansConfig?.label)
                          ?.monthly_premium
                      "
                    >
                    </span>
                    <span
                      class="ComparePlansHeader__PremiumPrice t-data"
                      [innerHTML]="
                        plan.price || 0 | currency: 'USD' : 'symbol' : '1.2-2'
                      "
                    >
                    </span>
                    <span
                      class="t-caption"
                      [innerHTML]="comparePlansConfig?.premiumSuffix"
                    ></span>
                  </ng-template>
                  @for (
                    highlight of getHighlights(plan) | keyvalue;
                    track highlight
                  ) {
                    <div>
                      <div class="u-flex u-justifyBetween u-alignCenter">
                        <p
                          class="t-data"
                          [innerHTML]="highlight.value.label"
                        ></p>
                        <h6 [innerHTML]="highlight.value.value"></h6>
                      </div>
                    </div>
                  }
                </div>
                <div class="u-flex u-justifyCenter">
                  @if (comparePlansConfig?.showEnroll) {
                    <zip-button
                      level="high"
                      [content]="
                        comparePlansConfig?.enrollButton ||
                        comparePlansConstantText.enrollText
                      "
                      (zipButtonClicked)="enroll(plan)"
                    >
                    </zip-button>
                  }
                </div>
              }
              @default {
                <h6
                  class="ComparePlansHeader__Title t-bold"
                  [innerHTML]="plan.display_name"
                ></h6>
                @if (!!plan.star_rating && comparePlansConfig?.showStarRating) {
                  <section class="ComparePlansHeader__Rating">
                    <star-rating [rating]="plan.star_rating"></star-rating>
                  </section>
                }
                <div class="u-flex u-justifyBetween u-alignCenter">
                  @if (plan.subsidyText?.value) {
                    <div class="premium">
                      <p
                        class="t-bold"
                        [innerHTML]="plan.subsidyText?.discountedPrice"
                      ></p>
                      <p
                        class="t-data"
                        [innerHTML]="plan.subsidyText?.subsidyLabel"
                      ></p>
                      <p
                        class="t-data"
                        [innerHTML]="plan.subsidyText?.originalPriceLabel"
                      ></p>
                      <br />
                    </div>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="withoutSubsidy"
                    ></ng-container>
                  }
                  <ng-template #withoutSubsidy>
                    <p class="t-data">
                      <span
                        class="t-bold"
                        [innerHTML]="
                          (
                            comparePlansConfig?.text ||
                            comparePlansConfig?.label
                          )?.monthly_premium
                        "
                      >
                      </span>
                      <span
                        class="ComparePlansHeader__PremiumPrice t-data"
                        [innerHTML]="
                          plan.price || 0 | currency: 'USD' : 'symbol' : '1.2-2'
                        "
                      >
                      </span>
                      <span
                        class="t-caption"
                        [innerHTML]="comparePlansConfig?.premiumSuffix"
                      ></span>
                    </p>
                  </ng-template>

                  @if (comparePlansConfig?.showEnroll) {
                    <zip-button
                      level="high"
                      [content]="
                        comparePlansConfig?.enrollButton ||
                        comparePlansConstantText.enrollText
                      "
                      (zipButtonClicked)="enroll(plan)"
                    >
                    </zip-button>
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </section>
  </div>
</header>
